import { render, staticRenderFns } from "./candidate_by_occupation.vue?vue&type=template&id=2bb39ba4&scoped=true&"
import script from "./candidate_by_occupation.vue?vue&type=script&lang=js&"
export * from "./candidate_by_occupation.vue?vue&type=script&lang=js&"
import style0 from "./candidate_by_occupation.vue?vue&type=style&index=0&id=2bb39ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb39ba4",
  null
  
)

export default component.exports